module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1201.9e726ea2.jpg";